<template>
  <div>
    <div class="ticket">
      <!-- ヘッダー -->
      <TheHeader :clickBackButtonEvent="returnNativeApp" />
      <!-- ヘッダー -->

      <!-- MasterBook・Bookのキービューの背景画像 -->
      <MbImageDisp
        v-if="masterBook.content"
        :url="masterBook.content.ticket_detail_image_url"
      />

      <!-- ブック詳細div -->
      <div class="ticket-detail">
        <!-- マスターブックタイトル・コメント -->
        <TheMbNameAndComment />
        <!-- マスターブックタイトル・コメント -->

        <!-- 料金 -->
        <TheMbPriceAndCaution />
        <!-- 料金 -->

        <!-- リンク集 -->
        <TheMbLinkCollection />
        <!-- リンク集 -->
      </div>

      <!-- ボトムに設置されるFIXED要素 -->
      <TheMbBottom />
      <!-- ボトムに設置されるFIXED要素 -->
    </div>
    <!-- ブック詳細div -->
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateMasterBook",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    return {
      masterBook,
    };
  },
};
</script>
